import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

export default function ManufacturingRoute() {
  const { tenantModule } = useAuth();
  if (tenantModule !== "manufacturing") {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
